<template>
    <div class="tab_content">
        <span class="tab_content-title">{{ $t('editorTabFontTitle') }}</span>
        <div class="tab_grid">
            <div
                v-for="(font, index) in fonts"
                class="font-family-item"
                :key="index"
                :style="`font-family: ${font.family}, ${font.generic}`"
                @click="addElement(font)"
            >
                {{ font.family }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { uuid } from 'vue-uuid';

    export default {
        data() {
            return {
                customFonts: []
            }
        },
        computed: {
            ...mapState([
                'fonts'
            ]),
            ...mapGetters([
                'getZIndex',
                'getActivePageId',
                'getSessionDetails',
                'getActivePage',
                'getCustomFonts'
            ])
        },
        methods: {
            addElement(text) {
                let newTextElement = {
                    id: uuid.v1(),
                    pageId: this.getActivePageId,
                    type: 'TEXT_ELEMENT',
                    isActive: true,
                    width: 200,
                    height: 100,
                    endValues: {
                        width: 200,
                        height: 100,
                    },
                    webSizeMM: {
                        width: 200 * 0.084667,
                        height: 100 * 0.084667,
                        translate: [0 * 0.084667, 0 * 0.084667]
                    },
                    frame: {
                        translate: [0, 0],
                        scale: [1, 1],
                        rotate: 0
                    },
                    font: {
                        family: text.family,
                        generic: text.generic,
                        weight: {
                            name: 'Regular',
                            value: 400,
                            style: 'normal'
                        },
                        align: 'left',
                        capitals: false,
                        underline: false,
                        size: 18,
                        // size: '12pt',
                        isEdited: false
                    },
                    placeholder: {
                        hasPlaceholder: false,
                        placeholderId: 'noPlaceholder',
                        placeholderSystemName: 'noPlaceholder'
                    },
                    color: {
                        rgb: 'rgb(2, 25, 4)',
                        hex: '021904',
                        X: 128,
                        Y: 8
                    },
                    content: this.$i18n.t('editorTabTextNewItemContent'),
                    svgContent: '',
                    zIndex: this.getZIndex,
                    isLocked: false,
                    newTransforms: true
                }

                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.$store.dispatch('ADD_PAGE_ELEMENT', newTextElement);
                    }
                } else {
                    this.$store.dispatch('ADD_PAGE_ELEMENT', newTextElement);
                }
            }
        }
    }
</script>